module.exports = __webpack_public_path__ + "static/media/whisky_Getty_cropped.d4ef5360.jpg";